/**
 * Channels Delete Policy
 * 
 * Handles channel deletion:
 * - Reacts when delete is confirmed
 * - Calls backend delete command
 * - Closes modal on success
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { ChannelsState } from '../state';
import { ChannelsCommand } from '../commands';

/**
 * Creates a policy that handles channel deletion
 */
export const createChannelsDeletePolicy = (
  backend: ClientLibraryType
): Policy<ChannelsState, ChannelsCommand> => ({
  name: 'channels-delete',

  shouldReact: ( prev, next ) => {
    // React when delete operation starts
    return (
      !prev.loading.deleting &&
      next.loading.deleting &&
      next.deleteModal.integrationId !== null
    );
  },

  onStateChange: async ({ next, ctx }) => {
    const { integrationId } = next.deleteModal;
    
    if ( !integrationId ) {
      console.error( '[channels] Delete called without channel ID' );
      ctx.dispatch(
        { type: 'integrations/channels/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
      return;
    }

    try {
      // TODO: Implement backend delete command when available
      // await backend.commands.DeleteSalesChannelIntegration({
      //   id: channelId
      // });
      console.warn( '[channels] Backend delete command not implemented yet' );

      // Optimistic remove (subscription will also handle this)
      ctx.dispatch(
        { type: 'integrations/channels/data/remove', payload: { integrationId }},
        { source: 'api' }
      );

      // Close modal and reset loading
      ctx.dispatch(
        { type: 'integrations/channels/delete/close', payload: {}},
        { source: 'api' }
      );
      ctx.dispatch(
        { type: 'integrations/channels/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
    } catch ( error ) {
      ctx.dispatch(
        { type: 'integrations/channels/loading/setDeleting', payload: { isLoading: false }},
        { source: 'api' }
      );
    }
  }
});
